import CourseAnnouncement from './AllAnnouncements';

export default CourseAnnouncement;
